<h1 mat-dialog-title>
  {{ 'sessionTimeoutDialog.title' | translate}}
</h1>

<div mat-dialog-content>
  <div [innerHtml]="'sessionTimeoutDialog.message' | translate"></div>
  @if (translate.currentLang ==='fr') {
    <div>
      Ensuite si vous désirez continuer de travailler, cliquer le bouton '<mat-icon >next_plan</mat-icon> <b class="renew-text">Renouveler session</b>' situé en haut de la page.
    </div>
  }
  @if (translate.currentLang ==='en') {
    <div>
      Click the '<mat-icon >next_plan</mat-icon> <b class="renew-text">Renew session</b>' button at the top of the page to continue working.
    </div>
  }
</div>

<div mat-dialog-actions
  class="justify-content-end">
  <button mat-raised-button
    color="primary"
  (click)="onCloseDialog()">{{ 'sessionTimeoutDialog.buttons.closeDialog' | translate}}</button>
</div>
